<template>
  <div class="page-404">
    <img src="@/assets/img/404.svg" />
    <p>
      Похоже, мы не можем найти <br />
      нужную Вам страницу
    </p>
    <button @click="back">Перейти на главную</button>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.push('/')
    }
  }
}
</script>
